// Cáscara del personalizador de lettering: pestañas, colores, formas de letra,
// "Mis diseños", ejemplos y el texto del pedido. El dibujo lo hace lettering.js.
(function(){
  const IG="https://ig.me/m/sugarpop_store";
  const SAVE_KEY="sugarpop.lettering.v1", GAL_KEY="sugarpop.letterings.v1", GAL_MAX=12;
  // Sin "anilla con cadena": Sebas la quitó el 6-oct-2026 (mucho trabajo a mano y a veces se abre).
  const COLGADORES=["Anilla clásica 30 mm","Cable de acero","Cadena de bolitas"];
  const INICIAL={texto:"Carla",formas:[],unColor:false,base:"MENTA",top:"VERDE OSCURO",anilla:COLGADORES[0]};

  let COLORES=[], VARIANTES={}, EJEMPLOS=[];
  const est=JSON.parse(JSON.stringify(INICIAL));
  let ULTIMO=null;            // lo que devolvió el motor la última vez (medidas)
  let ARMADO=false;           // no se autoguarda hasta terminar el arranque
  const $=id=>document.getElementById(id);
  const cv=$("lt-canvas");

  const letrasDe=t=>[...String(t||"").replace(/\s+/g,"")].slice(0,Lettering.MAX_LETRAS);
  const color=n=>COLORES.find(c=>c.name===n)||COLORES[0];
  const cm=v=>String(Math.round(v)/10).replace(".",",");

  // De un diseño (texto + forma elegida de cada letra) a lo que entiende el motor
  function paraMotor(d){
    const L=letrasDe(d.texto);
    const glifos=L.map((ch,i)=>{const v=VARIANTES[ch], k=(d.formas||[])[i]|0; return k&&v&&v[k-1] ? v[k-1] : ch;});
    return {glifos, base:color(d.base).hex, top:color(d.top||d.base).hex, unColor:!!d.unColor};
  }

  function pinta(){
    ULTIMO=Lettering.dibujar(cv,paraMotor(est));
    $("lt-vacio").hidden=!ULTIMO.vacio;
    $("lt-medida").textContent = ULTIMO.vacio ? "" :
      "Unos "+cm(ULTIMO.ancho_mm)+" × "+cm(ULTIMO.alto_mm)+" cm, más la anilla"+(ULTIMO.escala<1 ? " · se ajusta al largo máximo, de 9 a 9,5 cm" : "");
    pintaFormas(); pintaResumen(); guardaSolo();
  }

  // ── Texto y formas alternativas ──
  function ponTexto(t){
    const antes=letrasDe(est.texto), ahora=letrasDe(t);
    est.formas=ahora.map((ch,i)=>antes[i]===ch ? (est.formas[i]|0) : 0);   // la forma se conserva si la letra sigue en su sitio
    est.texto=t;
  }
  function pintaFormas(){
    const el=$("lt-formas-lista"); el.innerHTML=""; let hay=false;
    letrasDe(est.texto).forEach((ch,i)=>{
      const v=VARIANTES[ch]; if(!v) return; hay=true;
      const g=document.createElement("div"); g.className="fl";
      [ch].concat(v).forEach((gl,k)=>{
        const b=document.createElement("button"); b.type="button"; b.textContent=gl;
        b.className=(est.formas[i]|0)===k?"on":"";
        b.setAttribute("aria-label","Letra "+(i+1)+", forma "+(k+1));
        b.addEventListener("click",()=>{est.formas[i]=k; pinta();});
        g.appendChild(b);
      });
      el.appendChild(g);
    });
    $("lt-formas").hidden=!hay;
  }

  // ── Colores ──
  function listaColores(id,clave){
    const list=$(id); list.innerHTML="";
    COLORES.forEach(c=>{
      const it=document.createElement("div");
      it.className="color-item"+(est[clave]===c.name?" active":"");
      it.innerHTML='<div class="color-swatch'+(c.sparkle?" sparkle":"")+'" style="background-color:#'+c.hex+'"></div><div class="color-name"></div>';
      it.querySelector(".color-name").textContent=c.name;
      it.addEventListener("click",()=>{est[clave]=c.name; list.querySelectorAll(".color-item").forEach(x=>x.classList.remove("active")); it.classList.add("active"); pinta();});
      list.appendChild(it);
    });
  }
  function setSub(n){
    document.querySelectorAll(".subtab").forEach(b=>b.classList.toggle("active",b.dataset.sub===n));
    document.querySelectorAll(".swatches").forEach(s=>s.classList.toggle("active",s.dataset.sub===n));
  }
  function refrescaControles(){
    $("lt-txt").value=est.texto;
    document.querySelectorAll(".style-btn").forEach(b=>b.classList.toggle("active",(b.dataset.modo==="1")===est.unColor));
    $("subtab-top").classList.toggle("disabled",est.unColor);
    $("subtab-base").querySelector(".subtab-txt").textContent=est.unColor?"Color":"Base";
    if(est.unColor) setSub("base");
    listaColores("base-list","base"); listaColores("top-list","top");
    document.querySelectorAll(".anilla-btn").forEach(b=>b.classList.toggle("active",b.dataset.anilla===est.anilla));
  }

  // ── Resumen y pedido ──
  function lineas(){
    const L=letrasDe(est.texto), out=[["Palabra",L.join("")||"–"]];
    const f=L.map((ch,i)=>(est.formas[i]|0)?"letra "+(i+1)+" ("+ch+"), forma "+((est.formas[i]|0)+1):null).filter(Boolean);
    if(f.length) out.push(["Formas de letra",f.join("; ")]);
    if(est.unColor) out.push(["Color",est.base]);
    else { out.push(["Base",est.base]); out.push(["Letras",est.top]); }
    if(ULTIMO && !ULTIMO.vacio) out.push(["Tamaño aproximado",cm(ULTIMO.ancho_mm)+" × "+cm(ULTIMO.alto_mm)+" cm, más la anilla"]);
    out.push(["Colgador",est.anilla]);
    return out;
  }
  function pintaResumen(){
    const s=$("summary"); s.innerHTML="";
    lineas().forEach(([k,v])=>{const b=document.createElement("strong"); b.textContent=k+": "; s.append(b,document.createTextNode(v),document.createElement("br"));});
  }
  const textoPedido=()=>"LETTERING\n"+lineas().map(([k,v])=>k.toUpperCase()+": "+v).join("\n");
  function copiar(btn){
    const original=btn.dataset.label||btn.textContent; btn.dataset.label=original;
    const fin=(txt,ok)=>{btn.textContent=txt; btn.classList.toggle("ok",ok); setTimeout(()=>{btn.textContent=original; btn.classList.remove("ok");},2200); return ok;};
    if(!navigator.clipboard) return Promise.resolve(fin("No se pudo copiar",false));
    return navigator.clipboard.writeText(textoPedido()).then(()=>fin("✓ ¡Copiado!",true)).catch(()=>fin("No se pudo copiar",false));
  }

  // ── Guardado: el automático y "Mis diseños" ──
  function almacenOk(){ try{localStorage.setItem("__t","1");localStorage.removeItem("__t");return true;}catch(e){return false;} }
  const foto=()=>({v:1,texto:est.texto,formas:est.formas.slice(),unColor:est.unColor,base:est.base,top:est.top,anilla:est.anilla});
  function aplica(d){
    if(!d) return;
    est.texto=String(d.texto||""); est.formas=letrasDe(est.texto).map((_,i)=>((d.formas||[])[i]|0));
    est.unColor=!!d.unColor;
    if(COLORES.some(c=>c.name===d.base)) est.base=d.base;
    if(COLORES.some(c=>c.name===d.top)) est.top=d.top;
    if(COLGADORES.includes(d.anilla)) est.anilla=d.anilla;
    refrescaControles(); pinta();
  }
  let _t=null;
  function guardaSolo(){
    if(!ARMADO) return; clearTimeout(_t);
    _t=setTimeout(()=>{ try{localStorage.setItem(SAVE_KEY,JSON.stringify(foto())); $("saved").hidden=false;}catch(e){} },400);
  }
  // Miniatura: la misma pieza dibujada en un lienzo aparte y reducida
  function miniatura(d){
    const c=document.createElement("canvas"); const r=Lettering.dibujar(c,paraMotor(d)); if(!r||r.vacio) return "";
    const m=document.createElement("canvas"); m.width=330; m.height=138; m.getContext("2d").drawImage(c,0,0,330,138);
    try{ return m.toDataURL("image/png"); }catch(e){ return ""; }
  }
  function tarjeta(png,titulo,alCargar,alBorrar){
    const card=document.createElement("div"); card.className="dz-card";
    card.innerHTML='<button class="dz-ver" type="button"><span class="dz-mini"><img alt=""></span><span class="dz-tit"></span></button>';
    if(png) card.querySelector("img").src=png;
    card.querySelector(".dz-tit").textContent=titulo;
    const ver=card.querySelector(".dz-ver"); ver.setAttribute("aria-label","Cargar "+titulo); ver.addEventListener("click",alCargar);
    if(alBorrar){const x=document.createElement("button"); x.className="dz-x"; x.type="button"; x.textContent="✕"; x.setAttribute("aria-label","Borrar "+titulo); x.addEventListener("click",alBorrar); card.appendChild(x);}
    return card;
  }
  const leerGal=()=>{ try{const l=JSON.parse(localStorage.getItem(GAL_KEY)||"[]"); return Array.isArray(l)?l.filter(x=>x&&x.d):[];}catch(e){return [];} };
  const escribirGal=l=>{ try{localStorage.setItem(GAL_KEY,JSON.stringify(l)); return true;}catch(e){return false;} };
  let _tt=null;
  function cargar(d,titulo){
    const antes=foto(); aplica(d);
    const box=$("dz-toast"); $("dz-toast-txt").textContent="Cargado: "+titulo;
    $("dz-toast-undo").onclick=()=>{aplica(antes); box.hidden=true;};
    box.hidden=false; clearTimeout(_tt); _tt=setTimeout(()=>{box.hidden=true;},9000);
  }
  function pintarMios(nuevo){
    const w=$("dz-mios"); w.innerHTML="";
    leerGal().forEach(it=>{
      const tit=letrasDe(it.d.texto).join("")||"Diseño";
      const c=tarjeta(it.png,tit,()=>cargar(it.d,tit),()=>{escribirGal(leerGal().filter(x=>x.id!==it.id)); pintarMios();});
      if(it.id===nuevo) c.classList.add("nuevo"); w.appendChild(c);
    });
  }
  function guardarEnGal(btn){
    const flash=(t,c)=>{const o=btn.dataset.label||btn.textContent; btn.dataset.label=o; btn.textContent=t; btn.classList.add(c); setTimeout(()=>{btn.textContent=o; btn.classList.remove(c);},2200);};
    if(!letrasDe(est.texto).length){flash("Escribe una palabra","no");return;}
    const d=foto(), clave=JSON.stringify(d); let l=leerGal();
    const ya=l.find(x=>JSON.stringify(x.d)===clave);
    if(ya){escribirGal([ya].concat(l.filter(x=>x!==ya))); pintarMios(ya.id); flash("✓ Ya lo tenías","ok"); return;}
    if(l.length>=GAL_MAX){flash("Máximo "+GAL_MAX+": borra alguno","no");return;}
    const it={id:Date.now().toString(36)+Math.random().toString(36).slice(2,6),t:Date.now(),d,png:miniatura(d)};
    if(!escribirGal([it].concat(l))){flash("No se pudo guardar","no");return;}
    pintarMios(it.id); flash("✓ Guardado","ok");
  }
  function pintarEjemplos(){
    const w=$("dz-ejemplos"); w.innerHTML="";
    EJEMPLOS.forEach(e=>{
      const d={v:1,texto:e.texto,formas:e.formas||[],unColor:!!e.unColor,base:e.base,top:e.top||e.base};
      w.appendChild(tarjeta(miniatura(d),e.texto,()=>cargar(Object.assign({anilla:est.anilla},d),e.texto)));
    });
    const hay=w.children.length>0; $("dz-cab-ej").hidden=!hay; $("dz-nota-ej").hidden=!hay;
  }

  // ── Navegación ──
  function setTab(n){
    document.querySelectorAll(".tab").forEach(b=>{const on=b.dataset.tab===n; b.classList.toggle("active",on); b.setAttribute("aria-selected",on?"true":"false");});
    document.querySelectorAll(".pane").forEach(p=>p.classList.toggle("active",p.dataset.pane===n));
    const p=document.querySelector(".panels"); if(p) p.scrollTop=0;
  }
  function monta(){
    document.querySelectorAll(".tab").forEach(b=>b.addEventListener("click",()=>setTab(b.dataset.tab)));
    document.querySelectorAll(".subtab").forEach(b=>b.addEventListener("click",()=>setSub(b.dataset.sub)));
    document.querySelectorAll(".style-btn").forEach(b=>b.addEventListener("click",()=>{est.unColor=b.dataset.modo==="1"; refrescaControles(); pinta();}));
    $("lt-txt").addEventListener("input",e=>{ponTexto(e.target.value); pinta();});
    const ab=$("anilla-btns");
    COLGADORES.forEach(n=>{const b=document.createElement("button"); b.type="button"; b.className="anilla-btn"; b.dataset.anilla=n; b.textContent=n;
      b.addEventListener("click",()=>{est.anilla=n; refrescaControles(); pintaResumen(); guardaSolo();}); ab.appendChild(b);});
    const sb=$("sum-toggle"), ex=$("pedido-extra");
    sb.addEventListener("click",()=>{const a=ex.classList.toggle("abierto"); sb.setAttribute("aria-expanded",a?"true":"false"); $("sum-line").textContent=a?"Ocultar resumen":"Ver resumen y cómo colgarlo";});
    $("copy-btn").addEventListener("click",e=>{copiar(e.currentTarget).then(ok=>{ if(ok) setTimeout(()=>window.open(IG,"_blank","noopener"),350); });});
    $("copy-only").addEventListener("click",e=>copiar(e.currentTarget));
    const chip=$("saved-chip"), pop=$("saved-pop"), box=$("saved");
    chip.addEventListener("click",()=>{const a=pop.hidden; pop.hidden=!a; chip.setAttribute("aria-expanded",a?"true":"false");});
    document.addEventListener("pointerdown",e=>{ if(!pop.hidden && !box.contains(e.target)){pop.hidden=true; chip.setAttribute("aria-expanded","false");} });
    $("saved-del").addEventListener("click",()=>{ try{localStorage.removeItem(SAVE_KEY);}catch(e){} ARMADO=false; sessionStorage.setItem("sugarpop.lt.borrado","1"); location.reload(); });
    const g=$("dz-guardar");
    if(almacenOk()) g.addEventListener("click",()=>guardarEnGal(g));
    else { g.hidden=true; $("dz-nota").textContent="Este navegador no deja guardar diseños (puede ser la navegación privada)."; }
    window.addEventListener("resize",()=>{clearTimeout(monta._r); monta._r=setTimeout(pinta,150);});
  }

  // Los datos vienen dentro de la página cuando va en la tienda (window.LT_DATOS); en local se piden.
  const trae=(clave,ruta)=>(window.LT_DATOS&&window.LT_DATOS[clave]) ? Promise.resolve(window.LT_DATOS[clave])
    : fetch(ruta,{cache:"no-store"}).then(r=>r.ok?r.json():null).catch(()=>null);
  document.addEventListener("DOMContentLoaded",()=>{
    monta();
    Promise.all([trae("catalogo","../comun/catalog.json"), trae("variantes","../variantes.json"),
                 trae("ejemplos","ejemplos.json"), document.fonts.load("100px Aventura")]).then(([cat,va,ej])=>{
      COLORES=(cat&&cat.colors)||[{name:"MENTA",hex:"B3EDCB"},{name:"VERDE OSCURO",hex:"11806D"}];
      VARIANTES=va||{}; EJEMPLOS=(ej&&ej.ejemplos)||[];
      refrescaControles(); pinta(); pintarEjemplos();
      let hayGuardado=false;
      if(almacenOk()){
        pintarMios();
        const borrado=sessionStorage.getItem("sugarpop.lt.borrado")==="1"; if(borrado) sessionStorage.removeItem("sugarpop.lt.borrado");
        let d=null; try{d=JSON.parse(localStorage.getItem(SAVE_KEY)||"null");}catch(e){}
        if(!borrado && d && d.v===1){aplica(d); $("saved").hidden=false; hayGuardado=true;}
        ARMADO=true;
      }
      if(!hayGuardado && EJEMPLOS.length) setTab("disenos");   // primera visita: se empieza por los ejemplos
    });
  });
})();
